// index, about

$(() => {
    let scrollSwiper;

    const swiper = new Swiper('.swiper-container_gallery', {
        loop: true,
        slidesPerView: '1',
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-container_gallery .swiper-navigation-next",
            prevEl: ".swiper-container_gallery .swiper-navigation-prev"
        },
        speed: 1000,
        updateOnWindowResize: "true",
        effect: "slide",
        pagination: {
            el: ".swiper-container_gallery .swiper-pagination",
            clickable: true,
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
            waitForTransition: true,
        },
    });

    swiper
        .on('autoplayStop', () => {
            // При остановке скрываем мини-прогресс-бар таймера перехода
            $('.swiper-pagination-bullet-active').removeClass('swiper-pagination-bullet-active');
        })
        .on('autoplayStart', () => {
            // При старте получаем текущий элемент прогресс-бара по индексу слайда, чтоб не было дублирования активных слайдеров :)
            // (при ручном переключении текущий элемент может измениться, поэтому лучше по индексу смотреть)
            $('.swiper-pagination-bullet').eq(swiper.activeIndex-1).addClass('swiper-pagination-bullet-active');
        });


    $(window).on("scroll", function () {
        if (window.scrollY > 50) {
            $('header').addClass("scroll")
            $('.header-top').addClass("hide")
            $('.logo-top').addClass("scroll")
            $('.logo-wrapper').addClass("scroll")
            $('.header-content').addClass("scroll")
            $('.header-bottom').addClass("scroll")
            $('.slider').addClass("scroll")
            $('.main').addClass("scroll")
            $('.swiper-container_gallery .swiper-wrapper .swiper-slide').addClass("img-scroll")
            $('.past-bel-wrapper').addClass("scroll")

            scrollSwiper = false;
            $('.gallery-slide').addClass('scroll');
            try {
                swiper.autoplay.stop();
                swiper.allowTouchMove = false;
            } catch (e) {
            }

            $('.swiper-container_gallery .swiper-pagination').hide();
            $('.swiper-container_gallery .swiper-navigation-prev').hide();
            $('.swiper-container_gallery .swiper-navigation-next').hide();
        } else {
            $('header').removeClass("scroll")
            $('.header-top').removeClass("hide")
            $('.logo-top').removeClass("scroll")
            $('.logo-wrapper').removeClass("scroll")
            $('.header-content').removeClass("scroll")
            $('.header-bottom').removeClass("scroll")
            $('.slider').removeClass("scroll")
            $('.main').removeClass("scroll")
            $('.swiper-container_gallery .swiper-wrapper .swiper-slide').removeClass("img-scroll")
            $('.past-bel-wrapper').removeClass("scroll")

            scrollSwiper = true;
            $('.gallery-slide').removeClass('scroll');
            try {
                swiper.autoplay.start();
                swiper.allowTouchMove = true;
            } catch (e) {
            }

            $('.swiper-container_gallery .swiper-pagination').show();
            $('.swiper-container_gallery .swiper-navigation-next').show();
            $('.swiper-container_gallery .swiper-navigation-prev').show();
        }
    })

    try {
        const gSlide = $('.gallery-slide');

        gSlide.not('.scroll').mousemove(function () {
            if (scrollSwiper === true) {
                swiper.autoplay.stop();
                let activeSpan =
                    $(this)
                        .parent('.swiper-container')
                        .find('.swiper-pagination')
                        .children('.swiper-pagination-bullet.swiper-pagination-bullet-active');
                activeSpan.addClass('current-span');
                activeSpan.siblings().removeClass('current-span');
                activeSpan.removeClass('swiper-pagination-bullet-active');
            }
        });

        gSlide.not('.scroll').mouseleave(function () {
            if (scrollSwiper === true) {
                swiper.autoplay.start();
                let currentSpan = $('.current-span');
                currentSpan.addClass('swiper-pagination-bullet-active');
                currentSpan.removeClass('current-span');
            }
        });
    } catch (e) {
    }
});
